module.exports = __webpack_public_path__ + "fa0100218e40c602ba0e7d70813acddd.pdf";